import React, { useEffect } from "react";
import { Button, Col, Form, Modal } from "react-bootstrap";
import styles from "../EquipmentPop/EquipmentPop.module.scss";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const validationSchema = yup.object().shape({
  name: yup
    .string()
    .required("Please enter dietary preference name")
    .max(40, "Name cannot be more than 40 characters")
    .matches(/^[A-Za-z]+(?: [A-Za-z]+)*$/, "Only letters and single spaces allowed, no leading spaces")

});

const DietaryPreferencesModal = ({
  modalOpen,
  setModalOpen,
  edit,
  onSave,
  isAdding,
  isUpdating,
  dietaryList = [], // Accept dietaryList prop for future use
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    defaultValues: {
      name: "",
    },
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    if (edit) {
      setValue("name", edit.name || "");
    } else {
      reset({ name: "" });
    }
  }, [edit, setValue, reset]);

  const hideHandler = () => {
    setModalOpen(false);
    reset();
  };

  const onSubmit = (data) => {
    onSave({ ...edit, ...data });
  };

  return (
    <Modal
      show={modalOpen}
      className={`${styles.EquipmentPop} transparentModal`}
      onHide={hideHandler}
      backdrop={true}
      keyboard={false}
      centered
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="mx-auto">
          <h3 className="m-0 fw-bold themeBlue">
            {edit ? "Edit Dietary Preference" : "Add Dietary Preference"}
          </h3>
          <Col lg="12" className="my-2">
            <Form onSubmit={handleSubmit(onSubmit)}>
             
              <Col lg="12" md="12" className="my-2">
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Name
                  </label>
                  <input
                    type="text"
                    placeholder="e.g. Vegan, Gluten-Free"
                    className="form-control"
                    {...register("name")}
                  />
                  {errors.name && (
                    <span className="text-danger">
                      {errors.name.message}
                    </span>
                  )}
                </div>
              </Col>
              {/* Submit & Cancel Buttons */}
              <Col lg="12" className="my-2">
                <div className="d-flex align-items-center justify-content-center gap-10">
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn"
                    type="submit"
                    disabled={isAdding || isUpdating}
                  >
                    {isAdding || isUpdating
                      ? "Saving..."
                      : edit
                      ? "Update"
                      : "Add"}
                  </Button>
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                    type="button"
                    onClick={hideHandler}
                  >
                    Cancel
                  </Button>
                </div>
              </Col>
            </Form>
          </Col>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DietaryPreferencesModal;
